import { render, staticRenderFns } from "./importModelDialog.vue?vue&type=template&id=2e2f871d&scoped=true"
import script from "./importModelDialog.vue?vue&type=script&lang=js"
export * from "./importModelDialog.vue?vue&type=script&lang=js"
import style0 from "./importModelDialog.vue?vue&type=style&index=0&id=2e2f871d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f871d",
  null
  
)

export default component.exports